module.exports = __webpack_public_path__ + "static/media/pet(32x32).c05fcaa4.ico";